import React from 'react';
import { Star, TrendingUp, Sparkles } from 'lucide-react';
interface FeaturedExpert {
  id: string;
  name: string;
  category: string;
  description: string;
  url: string;
  badge: 'trending' | 'popular' | 'new';
  stats?: string;
}
const FEATURED: FeaturedExpert[] = [{
  id: 'featured-1',
  name: 'Financial Advisor GPT',
  category: 'Finance',
  description: 'Expert investment advice, portfolio analysis, and financial planning guidance',
  url: 'https://chatgpt.com/g/g-financial-advisor',
  badge: 'trending',
  stats: '50K+ users'
}, {
  id: 'featured-2',
  name: 'Health & Wellness Coach',
  category: 'Health',
  description: 'Personalized fitness plans, nutrition advice, and wellness strategies',
  url: 'https://chatgpt.com/g/g-health-wellness',
  badge: 'popular',
  stats: '100K+ users'
}, {
  id: 'featured-3',
  name: 'Career Development Mentor',
  category: 'Career',
  description: 'Resume optimization, interview prep, and career path guidance',
  url: 'https://chatgpt.com/g/g-career-mentor',
  badge: 'new',
  stats: 'New'
}];
export function FeaturedExperts() {
  const getBadgeIcon = (badge: string) => {
    switch (badge) {
      case 'trending':
        return <TrendingUp size={14} data-id="element-120" />;
      case 'popular':
        return <Star size={14} data-id="element-121" />;
      case 'new':
        return <Sparkles size={14} data-id="element-122" />;
      default:
        return null;
    }
  };
  const getBadgeColor = (badge: string) => {
    switch (badge) {
      case 'trending':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'popular':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'new':
        return 'bg-green-100 text-green-700 border-green-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  };
  return <div className="mb-12" data-id="element-123">
      <div className="flex items-center gap-3 mb-6" data-id="element-124">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-500 grid place-items-center" data-id="element-125">
          <Star size={20} className="text-white" data-id="element-126" />
        </div>
        <div data-id="element-127">
          <h2 className="text-2xl font-bold" data-id="element-128">Featured Expert Advisors</h2>
          <p className="text-sm text-slate-600" data-id="element-129">
            Top-rated AI experts across all categories
          </p>
        </div>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-130">
        {FEATURED.map(expert => <div key={expert.id} className="group relative rounded-2xl bg-gradient-to-br from-white to-slate-50 border-2 border-slate-200 hover:border-slate-300 shadow-lg hover:shadow-xl transition-all p-6" data-id="element-131">
            <div className="flex items-start justify-between mb-4" data-id="element-132">
              <span className={`inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border font-semibold ${getBadgeColor(expert.badge)}`} data-id="element-133">
                {getBadgeIcon(expert.badge)}
                {expert.badge.charAt(0).toUpperCase() + expert.badge.slice(1)}
              </span>
              <span className="text-xs text-slate-500 font-medium" data-id="element-134">
                {expert.stats}
              </span>
            </div>

            <h3 className="text-xl font-bold mb-2 group-hover:text-slate-900" data-id="element-135">
              {expert.name}
            </h3>
            <p className="text-sm text-slate-600 mb-1 font-medium" data-id="element-136">
              {expert.category}
            </p>
            <p className="text-sm text-slate-700 mb-6 line-clamp-2" data-id="element-137">
              {expert.description}
            </p>

            <a href={expert.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full rounded-xl px-4 py-3 bg-slate-900 text-white font-semibold hover:bg-black transition-colors" data-id="element-138">
              Start Conversation ↗
            </a>
          </div>)}
      </div>
    </div>;
}